import axios from 'axios'

export function fetchData(keyword) {
  return axios.get('https://www.geld.tech/twitter-github-mashup-api/search/' + keyword).then(response => { return response.data }).catch(error => { /* console.error(error); */ return Promise.reject(error) })
}



// WEBPACK FOOTER //
// ./src/api/index.js